import React from "react";
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { createPlan } from "../../../../../apis/options/PlanApi";
import './AddPlanStyles.css';
import { useHistory } from "react-router-dom";
import { Card } from "react-bootstrap";

const schema = yup
  .object({
    name: yup.string().required(),
    maxPlanOptions: yup.number().positive().integer().required(),
    startDate: yup.date().required(),
    optionsExpireAfterInYears: yup.number().positive().integer().required()
  })
  .required()


export default function AddPlanForm() {

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  const history = useHistory();

  const addPlan = (data) => 
  {
    createPlan(data)
    .then( _ => {
      history.push("/options/plans/summary");
    })
    .catch( _ => {
      history.push("/options/plans/summary");
    });
  }

  const handleCancel = _ =>
  {
    history.push("/options/plans/summary");
  }

  return (
    <Card style={{ width: '18rem' }}>
      <Card.Body>
        <Card.Title>New Plan</Card.Title>
        <Card.Text>
          <Form noValidate 
              onSubmit={handleSubmit(addPlan)}>
                
              <Form.Group>
                <Form.Label>Plan Name</Form.Label>
                <Form.Control isInvalid={!!errors.name} type="text" placeholder="Plan Name" {...register("name")} />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Maximum Options Available</Form.Label>
                <Form.Control isInvalid={!!errors.maxPlanOptions} type="text" placeholder="Max Options Available" {...register("maxPlanOptions")} />
                <Form.Control.Feedback type="invalid">{errors.maxPlanOptions?.message}</Form.Control.Feedback>
              </Form.Group>                  
              <Form.Group>
                <Form.Label>Start Date</Form.Label>
                <Form.Control isInvalid={!!errors.startDate} type="date" placeholder="Start Date" { ...register("startDate")} />
                <Form.Control.Feedback type="invalid">{errors.startDate?.message}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Options Expire After</Form.Label>
                <Form.Control isInvalid={!!errors.optionsExpireAfterInYears} type="text" placeholder="Options Expire After" {...register("optionsExpireAfterInYears")} /> (in years)
                <Form.Control.Feedback type="invalid">{errors.optionsExpireAfterInYears?.message}</Form.Control.Feedback>
              </Form.Group>
              <Button variant="primary" type="submit">
                Add
              </Button>
              <Button variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
          </Form>
        </Card.Text>
      </Card.Body>
    </Card>


  );
}